
export class ParentRouter{
    buildQuery(route, query, parent)
    {
        const queryData = {...query}

        if (queryData){
            const routeQuery = route.url.match(RegExp(parent, 'g'))
            if (routeQuery){
                routeQuery.map((itemQuery)=>{
                    const key = itemQuery.slice(1,-1)
                    if (queryData[key]){
                        route.url = route.url.replace(itemQuery, queryData[key])
                        delete queryData[key]
                    }else {
                        throw new Error(`#buildQuery Не найден ключ у роута. key = ${key} routeName = ${route.name} routUrl = ${route.url} queryData = ${JSON.stringify(queryData)}`)
                    }
                })
            }

            return this.buildOtherQuery(route, queryData)
        }

        return route
    }

    buildOtherQuery(route, queryData){
        if (Object.keys(queryData).length){
            let routeQuery = ''
            for (let key in queryData) {
                routeQuery += `${key}=${queryData[key]}&`
            }
            route.url = `${route.url}?${routeQuery.slice(0, -1)}`
        }

        return route
    }
}